// eslint-disable-next-line import/prefer-default-export
export function square(size) {
  return {
    height: size,
    width: size
  };
}